export const enum NavigationArrow {
  PREV = 'previous',
  NEXT = 'next'
}
/* eslint-disable sonarjs/no-duplicate-string */
const getImageUrl = (filePath: string) => {
  return require(`../assets/images/${filePath}`).default;
};

const getLocalVideoUrl = (filePath: string) => {
  return require(`../assets/videos/${filePath}`);
};

export const hero = {
  title: 'CELEBRATE COMMUNITY',
  subTitle: 'The future is yours. Learn directly from industry leaders only on adidas Community.',
  image: {
    data: getImageUrl('hero.png'),
    tabletData: getImageUrl('hero-tablet.png'),
    desktopData: getImageUrl('hero-desktop.png'),
    alt: 'Hero Video Poster'
  },
  video: {
    src: getLocalVideoUrl('hero-video.mp4'),
    tabletSrc: getLocalVideoUrl('hero-video.mp4'),
    desktopSrc: getLocalVideoUrl('hero-video.mp4')
  },
  cta: {
    href: 'https://community.adidas.com/signup',
    text: 'Join Now'
  }
};
export const wakanda = {
  title: 'Exclusive Courses',
  eyebrow: 'ADIDAS COMMUNITY',
  logo: {
    data: getImageUrl('logo-wakanda.png'),
    alt: 'adidas Wakanda Forever Logo'
  },
  bgImage: getImageUrl('video-texture.png'),
  videos: [
    {
      id: 1,
      src: getLocalVideoUrl('lead.mp4'),
      share: {
        title: 'Developing your own Black excellence with L.E.A.D.',
        description:
          'Gensen, Austin, and Desmond will teach you the history of the L.E.A.D. Center for Youth, and the process of transforming themselves from disadvantaged boys into successful young men by the time they graduated high school.',
        src: getLocalVideoUrl('lead-social.mp4'),
        fileName: 'Developing your own Black excellence with LEAD.mp4'
      },
      poster: { data: getImageUrl('lead-cover.png'), alt: 'L.E.A.D. course video poster' },
      heading: 'Developing your own Black excellence with L.E.A.D.',
      description:
        'Gensen, Austin, and Desmond will teach you the history of the L.E.A.D. Center for Youth, and the process of transforming themselves from disadvantaged boys into successful young men by the time they graduated high school.',
      cta: {
        href: 'https://community.adidas.com/topics/38944/page/content',
        title: 'Take Course'
      }
    },
    {
      id: 2,
      src: getLocalVideoUrl('isra.mp4'),
      share: {
        title: 'How to serve your community with integrity with Isra Hirsi',
        description: 'Serve your community by honing your ability to listen, empathize and provide space',
        src: getLocalVideoUrl('isra-social.mp4'),
        fileName: 'How to serve your community with integrity with Isra Hirsi.mp4'
      },
      poster: { data: getImageUrl('isracover.png'), alt: 'Isra course video poster' },
      heading: 'How to serve your community with integrity with Isra Hirsi',
      description: 'Serve your community by honing your ability to listen, empathize and provide space',
      cta: {
        href: 'https://community.adidas.com/topics/36811/page/content',
        title: 'Take Course'
      }
    }
  ],
  share: 'Share',
  patterns: {
    top: getImageUrl('course-pattern-top.png'),
    middle: getImageUrl('course-pattern-middle.png'),
    bottom: getImageUrl('course-pattern-bottom.png')
  }
};

export const community = {
  title: 'Creating Space to Build Confidence and Character',
  eyebrow: 'Community',
  description:
    'adidas Community is a digital network and radical resource for education, creative collaboration and growth opportunities.',
  cta: {
    href: 'https://community.adidas.com/signup',
    text: 'Create Account'
  },
  image: {
    data: getImageUrl('community.png'),
    tabletData: getImageUrl('community-tablet.png'),
    desktopData: getImageUrl('community-desktop.png'),
    alt: 'Community'
  }
};

export const carousel = {
  title: 'More Community Favorite Courses',
  data: [
    {
      id: 1,
      image: {
        data: getImageUrl('carousel-1.png'),
        alt: 'Ruth Carter'
      },
      title: 'Unlock Afrofuturism in Your Costume Design with Ruth Carter',
      description:
        'In this four-part adidas Community curriculum, ACADEMY AWARD® Winner Ruth Carter will walk you through her creative process, breaking down the steps to bring characters to life through storytelling and four crucial practices: Immersion, Imagination, Collaboration, and Innovation.',
      cta: 'https://community.adidas.com/topics/34691/page/content'
    },
    {
      id: 2,
      image: {
        data: getImageUrl('carousel-2.png'),
        alt: 'Protect Energy'
      },
      title: 'Protect your Energy with Alli Simon',
      description: 'Learn to care for the self with everyday tools and habits rooted in the practice of meditation.',
      cta: 'https://community.adidas.com/topics/30755/feed'
    },
    {
      id: 3,
      image: {
        data: getImageUrl('carousel-3.png'),
        alt: 'Our Metaverse'
      },
      title: 'Our Metaverse with Iddris Sandu',
      description:
        'This course was designed to encourage everyone—especially those who have historically been underserved by technology—to jump in.',
      cta: 'https://community.adidas.com/topics/31342/feed'
    }
  ],
  carouselCtaText: 'Get Started',
  cta: {
    href: 'https://community.adidas.com/topics',
    text: 'Explore All Courses'
  }
};

export const reviews = {
  title: 'Hear From Our Community Members',
  eyebrow: 'Reviews',
  data: [
    {
      id: 1,
      image: {
        data: getImageUrl('review-1.png'),
        dataMobile: getImageUrl('review-1-mobile.png'),
        alt: 'Testimonial Latiara'
      },
      quote:
        'I am glad that [the adidas Community platform] exists, there is a space that people can share and express themselves.',
      name: 'LaTiara Love'
    },
    {
      id: 2,
      image: {
        data: getImageUrl('review-2.png'),
        dataMobile: getImageUrl('review-2-mobile.png'),
        alt: 'Testimonial Tanika'
      },
      quote:
        'I love [the adidas Community platform] because it is a place to showcase your talent and display your artwork. It feels good saying I have a portfolio with adidas.',
      name: 'Tanika Salmon'
    },
    {
      id: 3,
      image: {
        data: getImageUrl('review-3.png'),
        dataMobile: getImageUrl('review-3-mobile.png'),
        alt: 'Testimonial Roc'
      },
      quote: `I enjoy the learning opportunities in the Adidas community. Alli's meditation course has been so helpful to my everyday life. The Metaverse course was also dope and broke the topic down well.`,
      name: 'Roc Jones'
    }
  ]
};

export const courses = {
  title: ' Get Access To:',
  eyebrow: 'Our Courses',
  card: [
    {
      id: 1,
      image: {
        data: getImageUrl('course-1.png'),
        alt: 'Community Curriculum'
      },
      heading: 'Community Curriculum',
      description: 'Take courses from unique mentors in sport, business, creativity, and purpose.',
      href: 'https://community.adidas.com/topics'
    },
    {
      id: 2,
      image: {
        data: getImageUrl('course-2.png'),
        alt: 'Peers Network'
      },
      heading: 'Network of Peers',
      description: 'A hub for community sharing among your peers and course mentors.',
      href: 'https://community.adidas.com/login'
    },
    {
      id: 3,
      image: {
        data: getImageUrl('course-3.png'),
        alt: 'Community Mentors'
      },
      heading: 'Community Mentors',
      description: 'Gain access to Community Mentors, the authors of their curriculum and industry experts.',
      href: 'https://community.adidas.com/page/mentors'
    },
    {
      id: 4,
      image: {
        data: getImageUrl('course-4.png'),
        alt: 'Career Opportunities'
      },
      heading: 'Career Opportunities',
      description:
        'Discover opportunities to build your skillset through job opportunities and collaborative projects.',
      href: 'https://community.adidas.com/opportunities'
    }
  ],
  ctaText: 'Learn More'
};

export const banner = {
  title: 'The Future of Adidas Community Is Coming',
  eyebrow: `Be Part Of What's Next`,
  description: `adidas Community is more than a platform, it's 
    a mindset. It's a new classroom and window to the world, a space for collaboration and connection, a chance to create the future. And we're just getting started.`,
  image: {
    data: getImageUrl('banner.png'),
    tabletData: getImageUrl('banner-tablet.png'),
    desktopData: getImageUrl('banner-desktop.png'),
    alt: 'The Future of adidas Community'
  },
  cta: {
    href: 'https://community.adidas.com/signup',
    text: 'Join Today'
  }
};

export const shareCopy = {
  facebook: 'Facebook Share',
  linkedin: 'LinkedIn Share',
  twitter: 'Twitter Share',
  copy: 'Copy Current Page Link',
  share: 'Share',
  copied: 'Copied'
};
